import { mapGetters } from "vuex";

import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import { GridAction } from "@/components/child/grid/gridAction";
import { GridColors, GridColumnSearchColor, GridColumnType } from "@/components/child/grid/gridColumn";
import ImpressaoComponent from "@/components/child/impressao/impressaoComponent";
import impressaoComponent from "@/components/child/impressao/impressaoComponent.vue";
import { Component, Watch } from "@/decorators";
import DestinosManipulacao from "@/models/enum/destinosManipulacao";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import TipoBuscaManipulacao from "@/models/enum/manipulacao/tipoBuscaManipulacao";
import SituacoesManipulacaoOrdem from "@/models/enum/situacoesManipulacaoOrdem";
import ManipulacaoOrdemModel, { ManipulacaoOrdemListParameters } from "@/models/manipulacaoOrdemModel";
import ModeloImpressaoModel from "@/models/modeloImpressao/modeloImpressaoModel";
import PaginationModel from "@/models/paginationModel";
import ManipulacaoOrdemService from "@/services/manipulacaoOrdemService";
import ModeloImpressaolService from "@/services/modeloImpressaoService";
import { Getters } from "@/store/store";
import { convertToDateInput, convertToDateInputString } from "@/utils/common/date";

import ListComponentBase from "../crud/listComponentBase";
import PrintModel from "../printModel/printModel";

import "./list.scss";

@Component({
    components: {
        comboComponent,
        dateTimePickerComponent,
        impressaoComponent,
    },
    computed: {
        ...mapGetters(["VALIDAR_PERMISSAO_USUARIO"] as Getters),
    },
})
export default class ManipulacaoOrdemListFormulaPadraoComponent extends ListComponentBase<ManipulacaoOrdemModel> {
    // State computed props
    VALIDAR_PERMISSAO_USUARIO: (telaDescricao: string, acaoController: string) => boolean;

    private manipulacaoOrdemService = new ManipulacaoOrdemService();

    private impressaoComponent: ImpressaoComponent = null;

    isHidden = false;
    manipulacaoOrdemFiltro?: number = null;
    dataFilter1: Date = null;
    dataFilter2: Date = null;
    tipoBuscaManipulacao = 1;

    situacaoManipulacaoOptions: Array<Object> =
        EnumExtensions.getNamesAndValuesOrderedByValues(SituacoesManipulacaoOrdem);
    tipoBuscaManipulacaoOptions: Array<Object> = [
        { text: "Código", value: TipoBuscaManipulacao.Codigo },
        { text: "Forma Farmacêutica", value: TipoBuscaManipulacao.FormaFarmaceutica },
        { text: "Paciente", value: TipoBuscaManipulacao.Paciente },
        { text: "Manipulação", value: TipoBuscaManipulacao.Manipulacao },
    ];

    gridSelectedValues: Array<ManipulacaoOrdemModel> = [];

    extraActions: Array<object> = [];
    gridExtraActionsImprimirRotulo: Array<GridAction> = [];
    gridExtraActionsImprimir: Array<GridAction> = [];

    get gridColumns(): Array<GridColumnSearchColor> {
        return [
            new GridColumnSearchColor("codigo", this.$t("__.ts.codigo"), GridColumnType.String),
            new GridColumnSearchColor("formulaPadraoDescricao", this.$t("__.ts.frmlPadrao"), GridColumnType.String),
            new GridColumnSearchColor(
                "formaFarmaceuticaDescricao",
                this.$t("__.ts.formfarmceu"),
                GridColumnType.String,
            ),
            new GridColumnSearchColor("situacaoDescricao", this.$t("__.ts.situacao"), GridColumnType.String, false),
            new GridColumnSearchColor("dataConclusao", this.$t("__.ts.dataConclusao"), GridColumnType.Date, false),
            new GridColumnSearchColor(
                "observacao",
                this.$t("__.Crud.cliente.edit_vue_html.obs"),
                GridColumnType.String,
                false,
            ),
        ];
    }

    private beforeMount() {
        this.setProps(new ManipulacaoOrdemService(), "manipulacaoordem", "codigo", false, "desc");
    }

    private getFormValues(listaFiltro: any) {
        this.filtros = [];
        this.filtros.push(this.manipulacaoOrdemFiltro);
        this.filtros.push(listaFiltro.target.elements.dataFilter1.value);
        this.filtros.push(listaFiltro.target.elements.dataFilter2.value);
        this.pageIndex = 1;
        this.load();
    }

    private onSelectedValuesChanged(values: Array<ManipulacaoOrdemModel>) {
        this.gridSelectedValues = values;
    }

    private async concluirManipulacoes() {
        if (this.gridSelectedValues.length > 0) {
            const ids = this.gridSelectedValues.map(p => p.id);

            const sucesso = await this.manipulacaoOrdemService.concluirLista(ids).withLoading().resolveWithoutJSON();
            if (sucesso) {
                await this.$showSuccess(this.$t("__.ts.conclManipu"), this.$t("__.ts.conclManipuMsg"));
                this.load();
            }
        } else {
            this.$showWarning(this.$t("__.ts.conclManipu"), this.$t("__.ts.nenhumRegisSelec"));
        }
    }

    public async loadMethod() {
        const customParameters: ManipulacaoOrdemListParameters = {
            destino: DestinosManipulacao.Estoque,
            situacao: this.filtros[0] != null && parseInt(this.filtros[0].toString()),
            dataInicial: convertToDateInputString(this.filtros[1]),
            dataFinal: convertToDateInputString(this.filtros[2], true),
            tipoBuscaManipulacao: this.tipoBuscaManipulacao,
        };

        return await this.manipulacaoOrdemService
            .listManipulacao(
                this.gridFilterKey,
                this.gridSortKey,
                this.gridSortOrder,
                this.pags ? 1 : this.pageIndex,
                this.pags ? 999999 : this.pageSize,
                customParameters,
            )
            .withLoading()
            .resolveWithJSON<PaginationModel<ManipulacaoOrdemModel>>();
    }

    public async afterLoad() {
        this.gridExtraActionsImprimir.splice(0);
        this.gridExtraActionsImprimirRotulo.splice(0);
        this.extraActions.splice(0);

        for (let i = 0; i < this.gridData.length; i++) {
            if (this.VALIDAR_PERMISSAO_USUARIO("manipulacoes_venda", "ImprimirManipulacao")) {
                this.gridExtraActionsImprimir.push(
                    new GridAction(
                        "imprimir-manipulacao",
                        this.$t("__.ts.printManipu") as string,
                        "fa fa-print",
                        GridColors.DARKGRAY,
                    ),
                );
            }

            if (this.VALIDAR_PERMISSAO_USUARIO("manipulacoes_venda", "ImprimirRotuloManipulacao")) {
                this.gridExtraActionsImprimirRotulo.push(
                    new GridAction(
                        "imprimir-manipulacao-rotulo",
                        this.$t("__.ts.printRotuloManipu") as string,
                        "fa fa-tag",
                        GridColors.GREEN,
                    ),
                );
            }
        }

        this.extraActions.push(this.gridExtraActionsImprimirRotulo);
        this.extraActions.push(this.gridExtraActionsImprimir);
    }

    private onExtraAction(name: string, model: ManipulacaoOrdemModel) {
        this.impressaoComponent = this.$refs.impressaoComponent as ImpressaoComponent;

        if (name.trim() == "imprimir-manipulacao") {
            this.impressaoComponent
                .show({
                    modelId: model.id,
                    tipoImpressao: "Manipulacao",
                    impressaoRotulo: false,
                    impressaoSelecionarModelo: true,
                })
                .withLoading();
        } else if (name.trim() == "imprimir-manipulacao-rotulo") {
            this.impressaoComponent
                .show({
                    modelId: model.id,
                    tipoImpressao: "Manipulacao",
                })
                .withLoading();
        }
    }

    private async imprimirSelecionados() {
        if (this.gridSelectedValues.length > 0) {
            try {
                const modelo = await new ModeloImpressaolService()
                    .GetPadraoByTelaName("manipulacao")
                    .resolveWithJSON<ModeloImpressaoModel>();

                const pages = await this.manipulacaoOrdemService
                    .getManyHTMLPage(
                        this.gridSelectedValues.map(x => x.id),
                        modelo.id,
                        1,
                        this.usuarioLogado.id,
                    )
                    .withLoading();

                const printModel = new PrintModel();
                printModel.showHTMLOnBrowser(pages.pageHtml, true);
            } catch (e) {
                await this.$showError(this.$t("__.ts.erroModeloImpressaoSemConteudo"), e.message);
            }
        } else {
            this.$showWarning(this.$t("__.ts.conclManipu"), this.$t("__.ts.nenhumRegisSelec"));
        }
    }

    public async onRemoveItem(model: ManipulacaoOrdemModel) {
        this.$router.push("/manipulacaoordem-cancelamento/" + model.id);
    }

    public onCreateItem() {
        this.$router.push("/formulapadrao-manipulacao");
    }

    public async afterLoadPagination() {
        if (this.paginationParams.filtros != null) {
            this.filtros = this.paginationParams.filtros;

            if (this.filtros.length >= 0) {
                if (this.filtros.length >= 1) {
                    if (this.filtros[1]) {
                        this.dataFilter1 = convertToDateInput(this.filtros[1].toString());
                    }
                }
                if (this.filtros.length >= 2) {
                    if (this.filtros[2]) {
                        this.dataFilter2 = convertToDateInput(this.filtros[2].toString());
                    }
                }
            }
        }
    }

    @Watch("tipoBuscaManipulacao")
    private onTipoBuscaManipulacao() {
        this.load();
    }
}
